export default __webpack_public_path__ + "static/media/serverSwitch.f7eaa897.svg";